export default "__VITE_PUBLIC_ASSET__56fb27b3__"